import { getVatAsync, saveVatAsync } from "../api/vat";

export const getVat = async () => await getVatAsync();

export const saveVat = async (formValue) => await saveVatAsync(formValue);
